module.exports = __webpack_public_path__ + "static/img/index15.6de7482.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index15.gif
// module id = 4CtC
// module chunks = 0